import { isAfter, isBefore, isEqual, format, startOfDay } from 'date-fns';
import AppConfig from 'app/Config';
import {
  DEFAULT_DATE_TIME_FORMAT,
  DEFAULT_DATE_FORMAT,
  ZERO_DATE,
  DEFAULT_SHORT_DATE_FORMAT,
  MERIDIEM_DATE_TIME_FORMAT,
} from 'app/constants/DateTimeFormat';

const toLocaleDateString = (date) => {
  let targetDate = date;
  if (typeof date === 'string') targetDate = new Date(date);
  if (!isValid(targetDate)) {
    return '';
  }

  return targetDate.toLocaleDateString();
};

const toDateString = (date) => {
  let targetDate = date;
  if (typeof date === 'string') targetDate = new Date(date);
  if (!isValid(targetDate)) {
    return '';
  }
  return format(targetDate, DEFAULT_DATE_FORMAT);
};

const toShortDateString = (date) => {
  let targetDate = date;
  if (typeof date === 'string') targetDate = new Date(date);
  if (!isValid(targetDate)) {
    return '';
  }
  return format(targetDate, DEFAULT_SHORT_DATE_FORMAT);
};

const toDateTimeString = (date) => {
  let targetDate = date;
  if (typeof date === 'string') targetDate = new Date(date);
  if (!isValid(targetDate)) {
    return '';
  }
  return format(targetDate, DEFAULT_DATE_TIME_FORMAT);
};

const toMeridiemDateTimeString = (date) => {
  let targetDate = date;
  if (typeof date === 'string') targetDate = new Date(date);
  if (!isValid(targetDate)) {
    return '';
  }
  return format(targetDate, MERIDIEM_DATE_TIME_FORMAT);
};

const isValid = (date) => {
  let targetDate = date;
  if (typeof date === 'string') targetDate = new Date(date);

  return isAfter(startOfDay(targetDate), AppConfig.minDate);
};

const isEqualOrAfter = (date, target) => {
  const _date = new Date(date);
  const _target = new Date(target);
  return !target || target === ZERO_DATE || isEqual(_date, _target) || isAfter(_date, _target);
};

const isEqualOrBefore = (date, target) => {
  const _date = new Date(date);
  const _target = new Date(target);
  return !target || target === ZERO_DATE || isEqual(_date, _target) || isBefore(_date, _target);
};

const removeTime = (date) => {
  const targetDate = new Date(date);
  if (!isValid(targetDate)) {
    return '';
  }
  targetDate.setHours(0, 0, 0, 0);
  return targetDate.toISOString();
};

// eslint-disable-next-line import/prefer-default-export
export {
  toLocaleDateString,
  toDateString,
  toShortDateString,
  isValid,
  toDateTimeString,
  removeTime,
  isEqualOrAfter,
  isEqualOrBefore,
  toMeridiemDateTimeString,
};
